import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../../pages/StaffDocuments.css';

// Home page: tells someone the club has shared a welfare outcome with them to
// read and sign. Shows nothing otherwise, or with no signal.
export default function WelfareOutcomesCard() {
  const [waiting, setWaiting] = useState(0);
  useEffect(() => {
    axios.get('/api/welfare/shared/mine')
      .then(res => setWaiting(res.data.filter(s => !s.acknowledgedAt).length))
      .catch(() => {});
  }, []);
  if (!waiting) return null;
  return (
    <div className="coc-card">
      <p><strong>{waiting === 1 ? 'You have a message from the club to read.' : `You have ${waiting} messages from the club to read.`}</strong></p>
      <Link to="/welfare-outcomes" className="bk-btn bk-btn--primary">Read</Link>
    </div>
  );
}
